import React from "react";
import SideMenu from "../../components/SideMenu";
import MyAccount from "./MyAccount";

export default function AccountDetails() {
  return (
    <div>
      <div className="container hideAt1300">
        <div className="row">
          <div className="col-3 side-menu-container">
            <SideMenu />
          </div>
          <div className="col mx-3">
            <MyAccount />
          </div>
        </div>{" "}
      </div>

      <div className="showAt1300">
      <MyAccount />
      </div>
    </div>
  );
}
